/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      thumbs: '[data-thumbs]',
      mediaItem: '[data-media-id]',
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider)?.querySelector(
          '[data-selected]',
        )?.dataset.index,
      ) || 0;
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
        thumbs: this.querySelector(this.selectors.thumbs),
      },
      instances: {
        slider: null,
        thumbs: null,
      },
      options: {
        slider: {
          effect: 'fade',
          initialSlide: this.selectedMediaIndex,
          spaceBetween: 20,
          watchOverflow: true,
          navigation: {
            prevEl: this.querySelector('.swiper-arrow--prev'),
            nextEl: this.querySelector('.swiper-arrow--next'),
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        },
        thumbs: {
          initialSlide: this.selectedMediaIndex,
          direction: 'vertical',
          slidesPerView: 4,
          spaceBetween: 30,
          navigation: {
            prevEl: this.querySelector('.product__media-thumbs .swiper-arrow--prev'),
            nextEl: this.querySelector('.product__media-thumbs .swiper-arrow--next'),
          },
        },
      },
    };
  }

  connectedCallback() {
    this.init();
    this.initImageCaption();
  }

  init() {
    if (!this.settings.elements.slider || !this.settings.elements.thumbs)
      return;

    this.settings.instances.thumbs = new Swiper(
      this.settings.elements.thumbs,
      this.settings.options.thumbs,
    );
    this.settings.options.slider.thumbs = {
      swiper: this.settings.instances.thumbs,
    };

    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }

  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem),
    ).find((media) => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    this.settings.instances.slider.slideTo(Number(mediaFound.dataset.index));
  }

  initImageCaption() {
    if (this.settings.instances.slider) {
      this.settings.instances.slider.on('slideChange', () => this.updateImageCaption());
    }
    // Defer so all sibling DOM nodes are guaranteed to be parsed and ready
    requestAnimationFrame(() => this.updateImageCaption());
  }

  updateImageCaption() {
    const captionEl = this.closest('.col--prod-image-slider')?.querySelector('.product__image-caption');
    if (!captionEl) return;

    let img;
    if (this.settings.instances.slider) {
      const idx = this.settings.instances.slider.activeIndex;
      const slides = Array.from(this.querySelectorAll('.swiper-wrapper > .swiper-slide'));
      img = slides[idx]?.querySelector('img');
    } else {
      img = this.querySelector('img');
    }

    const alt = (img?.getAttribute('alt') || '').trim();
    captionEl.textContent = alt;
    captionEl.hidden = !alt;
  }
}

customElements.define('product-media', ProductMedia);
